export const ADMIN = 'ROLE_PORTAL_ADMIN';
export const COMPANY_ADMIN = 'ROLE_COMPANY_ADMIN';
export const COMPANY_SUPER_USER = 'ROLE_COMPANY_SUPER_USER';
export const SCHOOL_ADMIN = 'ROLE_SCHOOL_ADMIN';
export const SCHOOL_SUPER_USER = 'ROLE_SCHOOL_SUPER_USER';
